// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__syltt","newExpiryDate":"styles_newExpiryDate__3TK0e","footer":"styles_footer__t-Xev"};